import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { useSiteSettings } from '../contexts/SiteSettingsContext';
const baseNav = [{
  label: 'Top 30',
  to: '/#top-30'
}, {
  label: 'Casino’s',
  to: '/#casinos',
  cta: true
}, {
  label: 'Providers',
  to: '/providers'
}, {
  label: 'Hoe wij beoordelen',
  to: '/#methode'
}, {
  label: 'Verantwoord gokken',
  to: '/#verantwoord'
}];
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const {
    showRealMoneyCtas
  } = useSiteSettings();
  const nav = baseNav.filter(n => !n.cta || showRealMoneyCtas);
  return <header className="sticky top-0 z-40 border-b border-line bg-paper/95 backdrop-blur" data-id="element-314" data-mp="zwsk2c47mde4">
      <div className="bg-fern-dark text-[12px] text-white/90" data-id="element-315" data-mp="2gb2bxg7nuk9p">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-1.5 sm:px-6" data-id="element-316" data-mp="2gdogr8362lo8">
          <p className="truncate" data-id="element-317" data-mp="2bev39fnvquo2">
            <span className="mr-2 rounded bg-white/15 px-1.5 py-0.5 font-semibold text-white" data-id="element-318" data-mp="29kbv1ovbb2ta">18+</span>
            Speel verantwoord · Gambling Helpline{' '}
            <a href="tel:0800654655" className="font-semibold text-white underline-offset-2 hover:underline" data-id="element-319" data-mp="2ekzqcmqkq5tb">
              0800 654 655
            </a>
          </p>
          <p className="hidden whitespace-nowrap sm:block" data-id="element-320" data-mp="2ofrsm3v3pguf">Bijgewerkt 6 oktober 2026</p>
        </div>
      </div>

      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6" data-id="element-321" data-mp="1quvnihl7ma3d">
        <Link to="/" className="flex items-baseline gap-1.5" aria-label="SlotGids home" data-id="element-322" data-mp="1vsx6l2imy9eu">
          <span className="font-serif text-2xl font-semibold tracking-tight text-ink" data-id="element-323" data-mp="20qqfi3bbphit">
            Slot<span className="text-oranje" data-id="element-324" data-mp="25j9zbi0lt8w2">Gids</span>
          </span>
          <span className="text-xs font-semibold text-fern" data-id="element-325" data-mp="1832zl1kzzf2i">.co.nz</span>
        </Link>

        <nav aria-label="Hoofdnavigatie" className="hidden lg:block" data-id="element-326" data-mp="1d1xmofpzzpsf">
          <ul className="flex items-center gap-7 text-sm font-medium text-muted" data-id="element-327" data-mp="1cztbrdtolqin">
            {nav.map(item => <li key={item.label} data-id="element-328" data-mp="14yvizok9wfhd">
                <Link to={item.to} className="whitespace-nowrap transition-colors duration-150 hover:text-ink" data-id="element-329" data-mp="102ww65elf5j2">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} className="rounded-md p-2 text-ink hover:bg-line/60 lg:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Menu sluiten' : 'Menu openen'} data-id="element-330" data-mp="19sgffc67x1eg">
          {open ? <XIcon className="h-5 w-5" data-id="element-331" data-mp="w1uw5mcuqpg1" /> : <MenuIcon className="h-5 w-5" data-id="element-332" data-mp="r1gldwjv91eb" />}
        </button>
      </div>

      <AnimatePresence data-id="element-333" data-mp="r05jk29ze3pu">
        {open && <motion.nav id="mobile-nav" aria-label="Mobiele navigatie" initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -6
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-paper lg:hidden" data-id="element-334" data-mp="27f73463wro6f">
            <ul className="mx-auto max-w-7xl px-4 py-2 sm:px-6" data-id="element-335" data-mp="2ewv6ndknghib">
              {nav.map(item => <li key={item.label} data-id="element-336" data-mp="211t5f3qqzgbu">
                  <Link to={item.to} onClick={() => setOpen(false)} className="block py-3 text-base font-medium text-ink" data-id="element-337" data-mp="250a2euggfafj">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}